<div class="datepicker-container" [class.has-error]="touched && required && !value">
  <label *ngIf="label" [for]="id || name" class="form-label">
    {{ label }}
    <span *ngIf="required" class="required-indicator">*</span>
  </label>

  <mat-form-field appearance="outline" class="datepicker-field">
    <input
      matInput
      [matDatepicker]="picker"
      [placeholder]="placeholder"
      [required]="required"
      [disabled]="disabled"
      [readonly]="readonly"
      [id]="id || name"
      [name]="name"
      [class]="class"
      [value]="value"
      [min]="minDate"
      [max]="maxDate"
      (dateChange)="onDateChange($event)"
    />

    <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="disabled || readonly" (click)="onFocus()">
      <mat-icon aria-label="Open calendar">calendar_today</mat-icon>
    </mat-datepicker-toggle>

    <mat-datepicker #picker [touchUi]="false" [startView]="'month'" [opened]="isOpen" (openedChange)="onPickerOpenedChange($event)">
    </mat-datepicker>

    <!-- <button
      *ngIf="value"
      type="button"
      class="datepicker-clear"
      (click)="clearDate()"
      [disabled]="disabled || readonly"
      matSuffix
      mat-icon-button
      title="Clear date"
    >
      <mat-icon aria-label="Clear date">clear</mat-icon>
      <span class="clear-text">×</span>
    </button> -->
  </mat-form-field>

  <!-- <div *ngIf="touched && required && !value" class="error-message">This field is required.</div> -->
</div>
